export default "__VITE_ASSET__7b7771aa__"